import { AppBar, Button } from "@mui/material";
import { styled } from "@mui/system";

export const StyledMenuButton = styled(Button, {
  // 'active'는 스타일 전용 prop이므로 DOM으로 전달되지 않게 막아 React 경고 제거
  shouldForwardProp: (prop) => prop !== "active",
})(({ theme, active, to }) => ({
  color: "white",
  position: "relative",
  fontFamily: "gmarket",
  pointer: to ? "pointer" : "none",
  fontSize: "16px",
  "&::before": {
    content: "''",
    position: "absolute",
    left: "50%",
    top: "-8px",
    transform: "translateX(-50%)",
    width: "9px",
    height: "9px",
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.orange,
    opacity: active ? 1 : 0,
    transition: "opacity 0.35s ease-in-out",
  },
  "&:hover::before, &:focus::before": {
    opacity: 1,
  },
}));

export const StyledAppBar = styled(AppBar, {
  // 'isHovered', 'isMainPage'는 스타일 전용 prop이므로 DOM으로 전달되지 않도록 필터링
  shouldForwardProp: (prop) => prop !== "isHovered" && prop !== "isMainPage",
})(({ theme, isHovered, isMainPage }) => ({
  maxWidth: "100%",
  backgroundColor: isMainPage
    ? isHovered
      ? `${theme.palette.primary.main}`
      : "rgba(0, 0, 0, 0.3)"
    : `${theme.palette.primary.main}`,
  backdropFilter: "blur(10px)",
  boxShadow: "none",
  "& .toolbar": {
    display: "flex",
    justifyContent: "space-between",
    "& .logo-button": {
      padding: 0,
      "& img": {
        width: "180px",
      },
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    "& .menus": {
      display: "flex",
      flexDirection: "row",
      height: "4rem",
      justifyContent: "space-between",
      gap: "2rem",
      alignItems: "center",
    },
  },
  "& .submenu-columns": {
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    position: "absolute",
    top: "100%", // Start right below the AppBar
    left: 0,
    right: 0,
    zIndex: 1000,
    padding: "1rem 3rem",
    background: `linear-gradient(to bottom, ${theme.palette.primary.main}, ${theme.palette.blue.light})`,
    "& .columns-container": {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      minWidth: "700px",
      marginLeft: "10rem",
      "& .submenu-column": {
        display: "flex",
        flexDirection: "row",
        alignItems: "start",
        padding: "1rem 0",
        width: "fit-content",
        gap: "2rem",
        transition: "opacity 0.5s ease",

        "& .children": {
          display: "flex",
          flexDirection: "column",
          width: "fit-content",
          gap: "1rem",
        },
        "& .grandchildren": {
          display: "flex",
          flexDirection: "column",
        },
      },
      "& button": {
        color: "white",
        width: "100%",
        justifyContent: "start",
        fontSize: "15px",
        fontFamily: "gmarket",
        "&:hover": {
          fontWeight: "bold",
        },
      },
      "& .title": {
        fontWeight: "bold",
        fontSize: "17px",
        textAlign: "left",
      },
    },
  },
  "& .menu-transition-enter": {
    opacity: 0,
    transform: "translateY(-20px)",
  },
  "& .menu-transition-enter-active": {
    opacity: 1,
    transform: "translateY(0)",
    transition: "opacity 400ms ease, transform 400ms ease",
  },
  "& .menu-transition-exit": {
    opacity: 1,
    transform: "translateY(0)",
  },
  "& .menu-transition-exit-active": {
    opacity: 0,
    transform: "translateY(-20px)",
    transition: "opacity 400ms ease, transform 400ms ease",
  },
  "& .item-enter": {
    opacity: 0,
    transform: "translateY(-20px)",
  },
  "& .item-enter-active": {
    opacity: 1,
    transform: "translateY(0)",
    transition: " opacity 400ms, transform 400ms",
  },
  "& .item-exit": {
    opacity: 1,
  },
  "& .item-exit-active": {
    opacity: 0,
    transform: "translateY(-20px)",
    transition: " opacity 200ms, transform 200ms",
  },
}));
